import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {TEMPLATE_RENDER_QUERY_KEY} from "../queryKeys";
import {ReachTemplateRenderResponse} from "./types";

export type {ReachTemplateRenderResponse};

type Variables = {
  account_id: number;
  template_id: number;
};

const renderTemplate = async (variables: Variables): Promise<ReachTemplateRenderResponse | null> => {
  if (!variables.account_id || !variables.template_id) return null;
  const response = await axiosReachInstance.post<
    ReachTemplateRenderResponse,
    AxiosResponse<ReachTemplateRenderResponse>
  >("/templates/render", variables);
  return response.data;
};

export const useRenderTemplate = (
  variables: Variables,
  options?: BaseQueryOptions<ReachTemplateRenderResponse | null, Variables>
): BaseUseQueryResult<ReachTemplateRenderResponse | null> =>
  useBaseQuery<ReachTemplateRenderResponse | null, Variables>(
    [TEMPLATE_RENDER_QUERY_KEY, variables.account_id, variables.template_id],
    renderTemplate,
    variables,
    options
  );
